import feelings from './feelings.json';
import money from './money.json';
import Dailyroutine from './Dailyroutines.json';
import clothes from './clothes and activities.json';
import bodyandhealth from './bodyandhealth.json';
import personalinfo from './personalinfo.json';
import travelandtransport from './travelandtransport.json';
import weather from './weather.json';

export const VOCABULARY_M4_U1 = [
    feelings,
    money,
    Dailyroutine,
    clothes,
    bodyandhealth,
    personalinfo,
    travelandtransport,
    weather
];